const imageSizes = [
  {label: 'Large (1920x1080)', value: 'lg'},
  {label: 'Medium (800x600)', value: 'md'},
  {label: 'Small (640x480)', value: 'sm'},
];

export {imageSizes};
